const getPeriodRange = (year: number, periodNumber: number, frequency: number = 3): any => {
  let endMonth = periodNumber * frequency - 1;
  let startMonth = endMonth - frequency + 1;

  return {
    startDate: new Date(year, startMonth, 1),
    endDate: new Date(year, endMonth + 1, 0),
  };
};

export default getPeriodRange;
